import { CashTransactionActions, CashTransactionActionTypes } from './CashTransactionActions';
import { CashTransaction } from '../../model/CashTransaction';
import { Json } from '../../model/Json'
;
export interface CashTransactionState {
  total: number;
  records: Json<string, CashTransaction>;
  message: string;
  status: string;
}

export const initialState: CashTransactionState = {
  total: 0,
  records: {},
  message: null,
  status: null
};

export function cashTransactionReducer(state: CashTransactionState = initialState, action: CashTransactionActions):  CashTransactionState {
  switch (action.type) {
    case CashTransactionActionTypes.InitCashTransactions: {
      const cashTransactions = {};
      action.payload.records.forEach(c => cashTransactions[c.postingRef] = mapRow(c));
      return {
        ...state,
        total: action.payload.total,
        records: cashTransactions,
        message: action.payload.message,
        status: action.payload.status
      };
    }
    case CashTransactionActionTypes.UpdateCashTransaction: {
      return {
        ...state,
        records: {
          ...state.records,
          [action.payload.postingRef]: action.payload
        }
      };
    }
    case CashTransactionActionTypes.RemoveCashTransaction: {
      const { [action.payload]: toRemoved, ...rest} = state.records;
      return {
        ...state,
        records: rest
      };
    }
    case CashTransactionActionTypes.AddCashTransaction: {
      return {
        ...state,
        records: {
          ...state.records,
          [action.payload.postingRef]: action.payload
        }
      };
    }
  }
  return state;
}

const mapRow = (row: CashTransaction): CashTransaction => {
  return {
    ...row,
    amount: Number(row.amount.toString().split(',').join(''))
  }
}

export const initCashTransactionState = (state: CashTransactionState) => state;
